module.exports = __webpack_public_path__ + "static/img/contact-banner.081f248.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contact-banner.png
// module id = Va8t
// module chunks = 2